import { render } from "./IntegracaoComp.vue?vue&type=template&id=72ba02bf&scoped=true"
import script from "./IntegracaoComp.vue?vue&type=script&lang=js"
export * from "./IntegracaoComp.vue?vue&type=script&lang=js"

import "./IntegracaoComp.vue?vue&type=style&index=0&id=72ba02bf&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ba02bf"]])

export default __exports__